import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {KnowledgeBaseMobileNavigation} from '@/components/knowledge-base/header/KnowledgeBaseMobileNavigation'
import {useCommonContent} from '@/content/common'
import {getTmAcademyContent} from '@/content/tm-academy/tmAcademy'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {AcademyContents} from '@/utils/contentful'
import {useLanguage} from '@/utils/i18n/language'

import {Sidebar} from '../sidebar/Sidebar'
import {SidebarSearchResults} from '../sidebar/SidebarSearchResults'
import {useAcademySearch} from './useAcademySearch'

type AcademyMobileNavigationProps = {
  isActive: boolean
  setMobileNavigationActive: (value: boolean) => void
  contents: AcademyContents
}

export const AcademyMobileNavigation: FC<React.PropsWithChildren<AcademyMobileNavigationProps>> = ({
  isActive,
  setMobileNavigationActive,
  contents,
}) => {
  const language = useLanguage()
  const {t} = useTranslation()

  const {academyLinkText} = getTmAcademyContent(language).header
  const {noResultsTitle} = useCommonContent()
  const {query, setQuery, hasQuery, articleLinks} = useAcademySearch(contents)

  const closeNavigation = () => setMobileNavigationActive(false)

  return (
    <KnowledgeBaseMobileNavigation
      title={t(academyLinkText)}
      query={query}
      setQuery={setQuery}
      isActive={isActive}
      toggleNavigation={() => setMobileNavigationActive(!isActive)}
      hasResults={!hasQuery || articleLinks.length > 0}
    >
      {hasQuery ? (
        articleLinks.length > 0 ? (
          <SidebarSearchResults
            data={articleLinks}
            searchWords={query.split(' ')}
            onClick={() => closeNavigation()}
          />
        ) : (
          <Text color={theme.palette.text.white}>{t(noResultsTitle)}</Text>
        )
      ) : (
        <Sidebar contents={contents} onClick={() => closeNavigation()} isMobile />
      )}
    </KnowledgeBaseMobileNavigation>
  )
}
